import classNames from "classnames";
import React from "react";
import CardContent from "../../../CardContent/CardContent";
import { ImageRatios } from "../../../Image/Image";
import ImageCard from "../../../ImageCard/ImageCard";
import WithSpacing from "../../../Spacing/Spacing";
import { StepData } from "../../stepper";
import StepperButton from "../../StepperButton/StepperButton";
import styles from "./StepperCard.module.scss";

interface StepperCardProps extends StepData {
  nextStep: boolean;
  text: string | undefined;
}

const StepperCard = (props: StepperCardProps) => {
  const {
    title,
    image,
    description,
    to,
    stepNumber,
    nextStep = false,
    text
  } = props;
  if (image && description) {
    return (
      <ImageCard
        className={classNames(styles.root, nextStep && styles.invertedColors)}
        widths={800}
        image={image}
        aspectRatio={ImageRatios.Landscape_4_3}
        href={to}
      >
        <WithSpacing>
          <div>
            <CardContent
              title={`${stepNumber}. ${title}`}
              titleVariant="h4"
              text={description}
              href={to}
              textMaxLines={3}
            />
            {nextStep && (
              <StepperButton
                className={styles.stepperButton}
                {...props}
                stepNumber={null}
                active={true}
                bold
                title={text ? text : title}
              />
            )}
          </div>
        </WithSpacing>
      </ImageCard>
    );
  }
  return null;
};

export default StepperCard;
